const APP_MAIN_HEADER_URL_TYPE = 'APP_MAIN_HEADER_URL_TYPE';
export default APP_MAIN_HEADER_URL_TYPE ;
